import { render, staticRenderFns } from "./CustomPermissionDetailShow.vue?vue&type=template&id=2103e76f&"
import script from "./CustomPermissionDetailShow.vue?vue&type=script&lang=js&"
export * from "./CustomPermissionDetailShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports